import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  title: {
    id: 'contactPersonSelector.title.label',
    description: 'Label for contact person selector title',
    defaultMessage: 'Choose contact person',
  },
  emptyContactPersonLabel: {
    id: 'contactPerson.selector.emptyLabel',
    description: 'Label for empty-option in contact person selector.',
    defaultMessage: 'Choose contact person',
  }
});
